import { render } from "./App.vue?vue&type=template&id=08976a9b&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=08976a9b&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__